import styled from "styled-components";
import { size } from "../../../style/util/size";
import { Icon } from "../Icon/Icon";
import { pseudo } from "../../../style/util/pseudo";
import { device } from "../../../style/util/media-query";

export const StyledDivider = styled.div`
  ${size("100%", "1.5rem")};
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.magenta};
  margin: 1rem 0;

  &::before {
    ${pseudo()};
    ${size("calc(100% - 3rem)", "0.2rem")};
    background-color: ${({ theme }) => theme.colors.magenta};
    margin-left: 1.5rem;
    top: 50%;
    transform: translateY(-50%);
  }

  @media ${device.desktop} {
    height: 2rem;

    &::before {
      height: 0.3rem;
    }
  }
`;

export const StyledIcon = styled(Icon)<{ $isSmall?: boolean }>`
  ${({ $isSmall }) =>
    $isSmall ? size("1.5rem", "100%") : size("3.4rem", "100%")};

  @media ${device.desktop} {
    width: ${({ $isSmall }) => ($isSmall ? "2rem" : "4.5rem")};
  }
`;
